import { Children, isValidElement } from "react";
import { useAdminAccess } from "../access/AdminAccessContext";

export default function SidebarGroup({ open, children, submenuId, ...props }) {
  const [heading, ...items] = Children.toArray(children);
  const { canVisit } = useAdminAccess();
  const visibleItems = items.filter(item => !isValidElement(item) || typeof item.props.to !== "string" || canVisit(item.props.to));
  return (
    <li {...props} className="admin-sidebar-group my-px w-full">
      {heading}
      <div
        id={submenuId}
        className="admin-submenu-grid"
        data-open={Boolean(open)}
        aria-hidden={!open}
        inert={open ? undefined : ""}
      >
        <div className="admin-submenu">{visibleItems}</div>
      </div>
    </li>
  );
}
